import * as React from 'react';
import {connect} from 'react-redux';
import * as UserModule from 'Modules/UserModule';
import * as ViewManagementModule from 'Modules/ViewManagementModule';
import {withTranslation} from 'react-i18next';
import {ParentDetails, CustomProps, IParentDetailsProps} from 'components/Layout/DetailsSidebar/ParentDetails';
import {Types} from 'Models/UserModel';
import {RootState} from 'Redux/Reducers/_RootReducer';
import {divIcon} from "leaflet";

interface IP extends IParentDetailsProps {
    history: any;
}

type ConnectedP = {
    elStore: UserModule.Types.UserStore;
};
type DispatchedP = {
    deleteEl: (userId: number) => Function;
    setActiveEl: (user: UserModule.Types.UserDto) => Function;
    showPopup: (popupData: ViewManagementModule.Types.Popup) => Function;
    t?: (key: string) => string;
    blockUser: (userId: number) => Function;
    unblockUser: (userId: number) => Function;
    resetPassword: (userEmail: string) => Function;
};

type itemRenderP = {
    label: string;
    imageName: string;
    clickHandler: Function;
};

type S = {};

class UserManagementListDetails extends ParentDetails<IP & ConnectedP & DispatchedP, S> {

    constructor(props: IP & ConnectedP & DispatchedP) {
        super(props);

        this.resetPassword = this.resetPassword.bind(this);
        this.manageUnblockClick = this.manageUnblockClick.bind(this);
        this.manageBlockClick = this.manageBlockClick.bind(this);
    }

    public getCustomProps(): CustomProps {
        const {PopupType} = ViewManagementModule.VMEnumTypes;
        const {
            elStore: {activeUser}
        } = this.props;

        return {
            ...(this.props as any),
            activeEl: activeUser,
            redirectUrlEdit: `/users-management/${activeUser ? activeUser.id : ''}`,
            redirectUrlAdd: '/users-management/add',
            popupTypeDelete: PopupType.DELETE_FLEET,
            labelAdd: this.props.t('add'),
            labelEdit: this.props.t('edit'),
            //labelDelete:this.props.t('delete'),
            extrnalRender: () => this.extrnalRender()
        };
    }

    protected resetPassword() {
        const {activeEl, showPopup, resetPassword} = this.getCustomProps();
        const {PopupType} = ViewManagementModule.VMEnumTypes;
        if (activeEl) {
            showPopup({
                type: PopupType.RESET_PASSWORD,
                confirmCallback: async () => {
                    await resetPassword(activeEl.email);
                }
            });
        }
    }

    protected manageBlockClick() {
        const {activeEl, showPopup, blockUser} = this.getCustomProps();
        const {PopupType} = ViewManagementModule.VMEnumTypes;
        if (activeEl) {
            showPopup({
                type: PopupType.BLOCK_USER,
                confirmCallback: async () => {
                    await blockUser(activeEl.id);
                }
            });
        }
    }

    protected manageUnblockClick() {
        const {activeEl, showPopup, unblockUser} = this.getCustomProps();
        const {PopupType} = ViewManagementModule.VMEnumTypes;
        if (activeEl) {
            showPopup({
                type: PopupType.UNBLOCK_USER,
                confirmCallback: async () => {
                    await unblockUser(activeEl.id);
                }
            });
        }
    }

    private itemRender(param: itemRenderP) {
        const {
            t,
            elStore: {activeUser}
        } = this.getCustomProps();

        return (
            <div
                className={`details-right__dashboard-item ${activeUser ? '' : 'details-right__dashboard-item--disabled'}`}
                onClick={() => param.clickHandler()}>
                <img src={`/images/icons/${param.imageName}.svg`} alt="" className="details-right__dashboard-icon"/>
                <span>{t(`tables:${param.label}`)}</span>
            </div>
        )
    }

    private extrnalRender() {
        const {
            t,
            elStore: {activeUser}
        } = this.getCustomProps();

        return (
            <>
                {
                    this.itemRender({
                            label: 'resetPassword',
                            imageName: 'key',
                            clickHandler: this.resetPassword
                        }
                    )
                }

                {activeUser && (activeUser as Types.UserDto).status == UserModule.UserEnumTypes.Status.BLOCKED ? (
                    this.itemRender({
                            label: 'unblockUser',
                            imageName: 'block_active',
                            clickHandler: this.manageUnblockClick
                        }
                    )
                ) : (
                    this.itemRender({
                            label: 'blockUser',
                            imageName: 'block_active',
                            clickHandler: this.manageBlockClick
                        }
                    )
                )}
            </>
        );
    }
}

function mapStateToProps(state: RootState): ConnectedP {
    return {
        elStore: state.userStore
    };
}

function mapDispachToProps(dispatch: any): DispatchedP {
    return {
        deleteEl: (userId: number) => dispatch(UserModule.Actions.deleteUser(userId)),
        setActiveEl: (user: UserModule.Types.UserDto) => dispatch(UserModule.Actions.setActiveUser(user)),
        showPopup: (popupData: ViewManagementModule.Types.Popup) => dispatch(ViewManagementModule.Actions.showPopup(popupData)),
        blockUser: (userId: number) => dispatch(UserModule.Actions.blockUser(userId)),
        unblockUser: (userId: number) => dispatch(UserModule.Actions.unblockUser(userId)),
        resetPassword: (userEmail: string) => dispatch(UserModule.Actions.resetPassword({email: userEmail} as UserModule.Types.RequestPasswordResetRequest))
    };
}

export default withTranslation(['carDetails', 'tables', 'form'])(
    connect(
        mapStateToProps,
        mapDispachToProps
    )(UserManagementListDetails) as React.ComponentType<any>
);



// WEBPACK FOOTER //
// ./src/components/Layout/DetailsSidebar/UserManagementListDetails.tsx